import React, { useState, useEffect } from "react";
import { Services } from "../../../../../Services";
import LinkClass from "./links.module.css";
import Skeleton from "./skeleton";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
// import PaymentGenerate from "../generatePaymentLink/generate";
import useStore from "../../../../../store";

function Transactions() {
    const [params] = useSearchParams();
    const [Loading, setLoading] = useState(true);
    const RecordCount = useStore((item) => item.NoOfRecords);
    const [transaction, setTransactions] = useState([]);
    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    useEffect(() => {
        getAllBarches();
    }, []);
    async function getAllBarches() {
        try {
            const Transactions = await Services.getdemoConversionFee(
                "GET",
                null,
                token,
                params.get("TutorId")
            );
            setTimeout(() => {
                setLoading(false);
            }, 500);
            if (Transactions.Status === 1) {
                setTransactions(Transactions.Data);
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
            alert("Something went wrong try again");
        }
    }

    return (
        <div className={LinkClass["Container"]}>
            {/* <header>
                <h3>Batches</h3>
            </header> */}
            {Loading ? (
                <Skeleton />
            ) : (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>From Tutor Name</th>
                                <th>To Tutor Name</th>
                                <th>Student Name</th>
                                <th>Type</th>
                                <th>Amount</th>
                                <th> Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {transaction.length > 0 ? (
                                transaction?.map((item) => (
                                    <tr>
                                        <td>{item?.FromTutorName}</td>
                                        <td>{item?.ToTutorName}</td>
                                        <td>{item?.StudentName}</td>
                                        <td>{item?.Credit_Or_Debit}</td>
                                        <td>{item?.Amount}</td>
                                        <td>
                                            {moment(item?.CreatedAt).format(
                                                "DD-MM-YYYY"
                                            )}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan={5}
                                        style={{ textAlign: "center" }}>
                                        No Record Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </>
            )}
        </div>
    );
}

export default Transactions;
